import { connect } from 'react-redux';
import Surface from './Surface';
function mapStateToProps(state) {
  return {
    theme: state.ui.theme.currentTheme || state.ui.theme.defaultTheme
  };
}
export default connect(mapStateToProps)(Surface);